const ADMIN_ROLE = 'admin';
const MENU_ADMIN_ROLE = 'menuAdmin';

// Role checks, mirroring checkAdminAccess / checkMenuAdminAccess in the server's
// util/requestUtils. Deliberately role-only: the server additionally requires a
// restaurantId claim, but it stays the authority on what a request may do - these
// only decide what the UI offers.
const checkAdmin = (user) => {
   if (user === null || user === undefined) {
      return false;
   }
   return user.role === ADMIN_ROLE;
};

// True for an admin too - an admin can do everything a menuAdmin can.
const checkMenuAdmin = (user) => {
   if (user === null || user === undefined) {
      return false;
   }
   return user.role === ADMIN_ROLE || user.role === MENU_ADMIN_ROLE;
};

const checkPermission = (user, permissionCode) => {
   if (user === null || user === undefined) {
      return false;
   }
   if (user.role !== null && (user.role === 'admin' || user.role === 'restaurantAdmin' || user.role === 'restaurantGroupAdmin')) {
       return true;
   }

   if (user.permissions === null || user.permissions === undefined || user.permissions.length === 0) {
      return false;
   }
    const permissionCodes = user.permissions.map(permission => permission.code);
    return permissionCodes.includes(permissionCode);
};

const PERMISSION_MYRESTAURANT = "myRestaurant";
const checkMyRestaurantPermission = (user) => {
   return checkPermission(user, PERMISSION_MYRESTAURANT);
};

const PERMISSION_MENU = "menuManagement";
const checkMenuPermission = (user) => {
   return checkPermission(user, PERMISSION_MENU);
};

const PERMISSION_ORDERS= "orders";
const checkOrdersPermission = (user) => {
   return checkPermission(user, PERMISSION_ORDERS);
};

const PERMISSION_TRANSACTIONS = "transactions";
const checkTransactionPermission = (user) => {
   return checkPermission(user, PERMISSION_TRANSACTIONS);
};

const PERMISSION_ORDER_REFUNDS = "orderRefunds";
const checkOrderRefundPermission = (user) => {
   return checkPermission(user, PERMISSION_ORDER_REFUNDS);
};

const PERMISSION_DEL_TRANSACTIONS = "delTransactions";
const checkDelTransactionsPermission = (user) => {
   return checkPermission(user, PERMISSION_DEL_TRANSACTIONS);
};

const PERMISSION_REPORTS = "reports";
const checkReportsPermission = (user) => {
   return checkPermission(user, PERMISSION_REPORTS);
};

const PERMISSION_BOOKING = "bookingManagement";
const checkBookingPermission = (user) => {
   return checkPermission(user, PERMISSION_BOOKING);
};

const PERMISSION_QUEUE = "queueManagement";
const checkQueuePermission = (user) => {
   return checkPermission(user, PERMISSION_QUEUE);
};

const PERMISSION_STAFF= "staffManagement";
const checkStaffPermission = (user) => {
   return checkPermission(user, PERMISSION_STAFF);
};

const PERMISSION_DISH_REPORT= "dishReportByOrders";
const checkDishOrderReportPermission = (user) => {
   return checkPermission(user, PERMISSION_DISH_REPORT);
};

export {
  checkAdmin,
  checkMenuAdmin,
  checkPermission,
  checkMyRestaurantPermission,
  checkMenuPermission,
  checkOrdersPermission,
  checkTransactionPermission,
  checkOrderRefundPermission,
  checkDelTransactionsPermission,
  checkReportsPermission,
  checkBookingPermission,
  checkQueuePermission,
  checkStaffPermission,
  checkDishOrderReportPermission
};